import { CombinedMessagesFiltersDto } from '@dealstack/frontend/app/pages/Project/MIP/hooks/useMessages.types';
import { DateTime } from 'luxon';

interface CreateMessagesFilterParams {
	searchQuery: string;
	selectedDates?: [Date | null, Date | null];
	investmentWorkflowId: string | null;
	documentWorkflowInstanceId: string | null;
}

export const createMessagesFilter = ({
	searchQuery,
	selectedDates,
	investmentWorkflowId,
	documentWorkflowInstanceId,
}: CreateMessagesFilterParams): CombinedMessagesFiltersDto => {
	const baseFilter = {
		searchQuery,
		pagination: {
			take: 25, // fixed page size for infinite scrolling
			skip: 0,
		},
		investmentWorkflowId: investmentWorkflowId ?? undefined,
		documentWorkflowInstanceId: documentWorkflowInstanceId ?? undefined,
	};

	if (selectedDates?.[0] && selectedDates?.[1]) {
		const from = DateTime.fromJSDate(selectedDates[0]).startOf('day').toISO() as string;
		const to = DateTime.fromJSDate(selectedDates[1]).endOf('day').toISO() as string;

		return {
			...baseFilter,
			fieldFilter: {
				createdAtRange: {
					from,
					to,
				},
			},
		};
	}

	return baseFilter;
};
